<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :rules="rules" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="年份" prop="year">
                <el-date-picker v-model="queryCondition.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="季度" prop="quarter">
                <el-select v-model="queryCondition.quarter" @change="quarterChange" placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in quarterOptions" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="月份" prop="month">
                <el-select v-model="queryCondition.month" placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in monthOptions" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport">导出</el-button>
      </el-row>
      <el-tabs type="border-card" @tab-click="handleClick" v-model="activeName">
        <el-tab-pane label="QSPI" name="QSPI">
          <el-row>
            <div class="title_box">
              <p class="line"></p>
              <p class="title">Performance By Supplier</p>
            </div>
          </el-row>
          <el-table ref="plxTable1" :data="supplierData1" max-height="500" border highlight-current-row>
            <el-table-column type="index" width="50" align="center" label="No."></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="评价月" prop="month" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Category" prop="category" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Facility Code" prop="facilityCode" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Facility Name" prop="facilityName" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Outbound" prop="outbound" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="AAA" prop="aaa" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QBR" prop="qbr" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="MSV" prop="msv" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SCHR" prop="swa" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SQMS" prop="sqms" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Cert" prop="govtCert" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Spec Compliance" prop="specComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="COA" prop="coa" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Reg Compliance" prop="regComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Plant Audit" prop="govtPlant" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Stock Recovery" prop="stockRecovery" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QIP" prop="qip" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Product Feedback" prop="feedback" min-width="140"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Sensory" prop="sensory" min-width="120"></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
            </el-pagination>
          </div>
          <el-row style="margin-top:10px">
            <div class="title_box">
              <p class="line"></p>
              <p class="title">Performance By Actual Volume</p>
            </div>
          </el-row>
          <el-table ref="plxTable2" :data="actualVolumeData1" max-height="500" border highlight-current-row>
            <el-table-column show-overflow-tooltip align="center" label="Grade" prop="grade" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="AAA" prop="aaa" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QBR" prop="qbr" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="MSV" prop="msv" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SCHR" prop="swa" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SQMS" prop="sqms" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Cert" prop="govtCert" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Spec Compliance" prop="specComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="COA" prop="coa" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Reg Compliance" prop="regComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Plant Audit" prop="govtPlant" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Stock Recovery" prop="stockRecovery" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QIP" prop="qip" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Product Feedback" prop="feedback" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Sensory" prop="sensory" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="DQMP" prop="dqmp" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Chicken" prop="rmcChick" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Produce" prop="rmcProduce" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Antibiotic Chicken" prop="antiChick" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Total" prop="total" min-width="100"></el-table-column>
          </el-table>
          <el-row style="margin-top:20px">
            <div class="title_box">
              <p class="line"></p>
              <p class="title">Performance By Percentage</p>
            </div>
          </el-row>
          <el-table ref="plxTable3" :data="percentageData1" max-height="500" border highlight-current-row>
            <el-table-column show-overflow-tooltip align="center" label="Grade" prop="grade" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="AAA" prop="aaa" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.aaa * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QBR" prop="qbr" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.qbr * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="MSV" prop="msv" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.msv * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SCHR" prop="swa" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.swa * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SQMS" prop="sqms" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.sqms * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Cert" prop="govtCert" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.govtCert * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Spec Compliance" prop="specComp" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.specComp * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="COA" prop="coa" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.coa * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Reg Compliance" prop="regComp" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.regComp * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Plant Audit" prop="govtPlant" min-width="120">
              <template slot-scope="scope">
                <span>{{(parseFloat((scope.row.govtPlant * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Stock Recovery" prop="stockRecovery" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.stockRecovery * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QIP" prop="qip" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.qip * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Product Feedback" prop="feedback" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.feedback * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Sensory" prop="sensory" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.sensory * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Consumer Feedback" prop="consumerFeedback" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.consumerFeedback * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="DQMP" prop="dqmp" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.dqmp * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Chicken" prop="rmcChick" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.rmcChick * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Produce" prop="rmcProduce" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.rmcProduce * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Antibiotic Chicken" prop="antiChick" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.antiChick * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Total" prop="total" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.total * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="FSQPI" name="FSQPI">
          <el-row>
            <div class="title_box">
              <p class="line"></p>
              <p class="title">Performance By Supplier</p>
            </div>
          </el-row>
          <el-table ref="plxTable1" :data="supplierData2" max-height="500" border highlight-current-row>
            <el-table-column type="index" width="50" align="center" label="No."></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="评价月" prop="month" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Category" prop="category" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Facility Code" prop="facilityCode" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Facility Name" prop="facilityName" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Outbound" prop="outbound" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="AAA" prop="aaa" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QBR" prop="qbr" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="MSV" prop="msv" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SCHR" prop="swa" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SQMS" prop="sqms" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Cert" prop="govtCert" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Spec Compliance" prop="specComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="COA" prop="coa" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Reg Compliance" prop="regComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Plant Audit" prop="govtPlant" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Stock Recovery" prop="stockRecovery" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QIP" prop="qip" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Product Feedback" prop="feedback" min-width="140"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Sensory" prop="sensory" min-width="120"></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
            </el-pagination>
          </div>
          <el-row style="margin-top:10px">
            <div class="title_box">
              <p class="line"></p>
              <p class="title">Performance By Actual Volume</p>
            </div>
          </el-row>
          <el-table ref="plxTable2" :data="actualVolumeData2" max-height="500" border highlight-current-row>
            <el-table-column show-overflow-tooltip align="center" label="Grade" prop="grade" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="AAA" prop="aaa" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QBR" prop="qbr" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="MSV" prop="msv" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SCHR" prop="swa" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SQMS" prop="sqms" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Cert" prop="govtCert" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Spec Compliance" prop="specComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="COA" prop="coa" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Reg Compliance" prop="regComp" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Plant Audit" prop="govtPlant" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Stock Recovery" prop="stockRecovery" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QIP" prop="qip" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Product Feedback" prop="feedback" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Sensory" prop="sensory" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="DQMP" prop="dqmp" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Chicken" prop="rmcChick" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Produce" prop="rmcProduce" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Antibiotic Chicken" prop="antiChick" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Total" prop="total" min-width="100"></el-table-column>
          </el-table>
          <el-row style="margin-top:20px">
            <div class="title_box">
              <p class="line"></p>
              <p class="title">Performance By Percentage</p>
            </div>
          </el-row>
          <el-table ref="plxTable3" :data="percentageData2" max-height="500" border highlight-current-row>
            <el-table-column show-overflow-tooltip align="center" label="Grade" prop="grade" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="AAA" prop="aaa" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.aaa * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QBR" prop="qbr" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.qbr * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="MSV" prop="msv" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.msv * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SCHR" prop="swa" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.swa * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="SQMS" prop="sqms" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.sqms * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Cert" prop="govtCert" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.govtCert * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Spec Compliance" prop="specComp" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.specComp * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="COA" prop="coa" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.coa * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Reg Compliance" prop="regComp" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.regComp * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov`t Plant Audit" prop="govtPlant" min-width="120">
              <template slot-scope="scope">
                <span>{{(parseFloat((scope.row.govtPlant * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Stock Recovery" prop="stockRecovery" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.stockRecovery * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="QIP" prop="qip" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.qip * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Product Feedback" prop="feedback" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.feedback * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Sensory" prop="sensory" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.sensory * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <!-- <el-table-column show-overflow-tooltip align="center" label="Consumer Feedback" prop="consumerFeedback" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.consumerFeedback * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column> -->
            <el-table-column show-overflow-tooltip align="center" label="DQMP" prop="dqmp" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.dqmp * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Chicken" prop="rmcChick" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.rmcChick * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="RMC Produce" prop="rmcProduce" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.rmcProduce * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Antibiotic Chicken" prop="antiChick" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.antiChick * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" :label="'Water safety \n & quality'" prop="waterSafety" min-width="130">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.waterSafety * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" :label="'3rd party FS \n Audit/FSPV'" prop="thirdPartyAudit" min-width="130">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.thirdPartyAudit * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" :label="'Gov’t audits \n & sampling'" prop="govtAudit" min-width="130">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.govtAudit * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Gov’t FS grading" prop="govtGrading" min-width="130">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.govtGrading * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="CSAT Quality" prop="csatQuality" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.csatQuality * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" :label="'Customer Feedback - \n Ops'" prop="consumerFeedbackOps" min-width="150">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.consumerFeedbackOps * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" :label="'Customer Feedback - \n SC'" prop="consumerFeedbackSc" min-width="150">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.consumerFeedbackSc * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Total" prop="total" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.total * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import qspiReport from "@/api/qspiReport/index";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'fspi',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      activeName: "QSPI",
      totalCount: 0,
      pages: 1,
      queryCondition: {
        year: "",
        month: 0,
        quarter: 0,
        type: "QSPI",
        pageSize: 15,
        pageNum: 1,
      },
      quarterOptions: [
        {
          label: "All",
          key: 0
        },
        {
          label: "Q1",
          key: 1
        },
        {
          label: "Q2",
          key: 2
        },
        {
          label: "Q3",
          key: 3
        },
        {
          label: "Q4",
          key: 4
        }
      ],
      monthOptions: [
        {
          label: "All",
          key: 0,
          quarter: ''
        },
        {
          label: "一月",
          key: "1",
          quarter: "Q1",
        },
        {
          label: "二月",
          key: "2",
          quarter: "Q1",
        },
        {
          label: "三月",
          key: "3",
          quarter: "Q1",
        },
        {
          label: "四月",
          key: "4",
          quarter: "Q2",
        },
        {
          label: "五月",
          key: "5",
          quarter: "Q2",
        },
        {
          label: "六月",
          key: "6",
          quarter: "Q2",
        },
        {
          label: "七月",
          key: "7",
          quarter: "Q3",
        },
        {
          label: "八月",
          key: "8",
          quarter: "Q3",
        },
        {
          label: "九月",
          key: "9",
          quarter: "Q3",
        },
        {
          label: "十月",
          key: "10",
          quarter: "Q4",
        },
        {
          label: "十一月",
          key: "11",
          quarter: "Q4",
        },
        {
          label: "十二月",
          key: "12",
          quarter: "Q4",
        }
      ],
      rules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'blur' },
        ],
      },
      supplierData1: [],
      actualVolumeData1: [],
      percentageData1: [],
      supplierData2: [],
      actualVolumeData2: [],
      percentageData2: [],
      excludesValue: []
    }
  },
  created() {
  },
  methods: {
    queryData() {
      this.$refs['queryCondition'].validate((valid) => {
        if (valid) {
          qspiReport.queryQspiPerformance(this.queryCondition.pageNum, this.queryCondition.pageSize, this.queryCondition.type, this.queryCondition.quarter, this.queryCondition.month, this.queryCondition.year).then(res => {
            if (this.activeName === 'QSPI') {
              this.supplierData1 = res.performanceBySupplier.resultData;
              this.totalCount = res.performanceBySupplier.totalCount;
              this.actualVolumeData1 = res.performanceSummary.volume;
              this.percentageData1 = res.performanceSummary.percentage;
            } else {
              this.supplierData2 = res.performanceBySupplier.resultData;
              this.totalCount = res.performanceBySupplier.totalCount;
              this.actualVolumeData2 = res.performanceSummary.volume;
              this.percentageData2 = res.performanceSummary.percentage;
            }
          });
        }
      })
    },
    quarterChange(val) {
      console.log('val', val);
      this.monthOptions = [
        {
          label: "All",
          key: 0,
          quarter: ''
        },
        {
          label: "一月",
          key: "1",
          quarter: "Q1",
        },
        {
          label: "二月",
          key: "2",
          quarter: "Q1",
        },
        {
          label: "三月",
          key: "3",
          quarter: "Q1",
        },
        {
          label: "四月",
          key: "4",
          quarter: "Q2",
        },
        {
          label: "五月",
          key: "5",
          quarter: "Q2",
        },
        {
          label: "六月",
          key: "6",
          quarter: "Q2",
        },
        {
          label: "七月",
          key: "7",
          quarter: "Q3",
        },
        {
          label: "八月",
          key: "8",
          quarter: "Q3",
        },
        {
          label: "九月",
          key: "9",
          quarter: "Q3",
        },
        {
          label: "十月",
          key: "10",
          quarter: "Q4",
        },
        {
          label: "十一月",
          key: "11",
          quarter: "Q4",
        },
        {
          label: "十二月",
          key: "12",
          quarter: "Q4",
        }
      ]
      if (val === 1) {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q1' || !ele.quarter
        })
      } else if (val === 2) {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q2' || !ele.quarter
        })
      } else if (val === 3) {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q3' || !ele.quarter
        })
      } else if (val === 4) {
        this.monthOptions = this.monthOptions.filter(ele => {
          return ele.quarter === 'Q4' || !ele.quarter
        })
      } else {
        this.monthOptions = this.monthOptions
      }
    },
    handleClick(tab, event) {
      if (tab.name == 'QSPI') {
        this.$set(this.queryCondition, 'type', 'QSPI')
      } else {
        this.$set(this.queryCondition, 'type', 'FSQPI')
      }
      this.queryData()
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        year: "",
        month: 0,
        quarter: 0,
        type: "QSPI",
        pageSize: 15,
        pageNum: 1,
      }
      if (this.activeName == 'QSPI') {
        this.$set(this.queryCondition, 'type', 'QSPI')
      } else {
        this.$set(this.queryCondition, 'type', 'FSQPI')
      }
      this.queryData();
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onExport() {
      console.log('this.queryCondition.type', this.queryCondition.type);
      this.$refs['queryCondition'].validate((valid) => {
        if (valid) {
          if (this.queryCondition.type === 'QSPI') {
            qspiReport.exportQspiFspi(this.queryCondition.pageNum, this.queryCondition.pageSize, this.queryCondition.type, this.queryCondition.quarter, this.queryCondition.month, this.queryCondition.year).then(res => {
              fileService.respToFile(res, 'QSPI_Performance报表.xlsx');
            });
          } else if (this.queryCondition.type === 'FSQPI') {
            qspiReport.exportQspiFspi(this.queryCondition.pageNum, this.queryCondition.pageSize, this.queryCondition.type, this.queryCondition.quarter, this.queryCondition.month, this.queryCondition.year).then(res => {
              fileService.respToFile(res, 'FSQPI_Performance报表.xlsx');
            });
          }
        }
      })

    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
